import React from 'react';
import { Well } from 'react-bootstrap';
import { Field, reduxForm } from 'redux-form';

import InputControl from './../../FormTemplate/InputControl';

class FeatureClassForm extends React.Component {

   render() {
      const { handleSubmit, saveNewFeatureClass } = this.props;
      return (
         <Well>
            Create New Feature Class
            <form noValidate autoComplete="off" onSubmit={handleSubmit(saveNewFeatureClass)} >
               <Field name="name" type="text" component={InputControl} />
               <button type="submit" >Save</button>
            </form>
         </Well>
      );
   }
}

FeatureClassForm.propTypes = {
   handleSubmit: React.PropTypes.func,
   saveNewFeatureClass: React.PropTypes.func
};

export default reduxForm({
   form: 'newFeatureClass'
})(FeatureClassForm);



/** WEBPACK FOOTER **
 ** ./src/components/ItemManagement/FeatureClass/FeatureClassForm.js
 **/